/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

/**
 * Source of the note
 */
export type IncidentNoteSource = (typeof IncidentNoteSource)[keyof typeof IncidentNoteSource];

export const IncidentNoteSource = {
  API: 'api',
  EMAIL: 'email',
  SMS: 'sms',
} as const;
